import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BClientFacturesUrl, BFactureUrl, CANCEL_TICKETS_URL, FACTURATION_URL, FACTURE_EDIT_URL, MAKE_DEVIS_URL, UPDATE_TICKETS_URL } from "../../settings/APISetting";
import { output } from "../../settings/themeSettings";
import axiosInstance from "../../config/axiosConfig"; // Import axiosInstance

export const fetchFactures = createAsyncThunk('fetch-factures', async (clientId) => {
    try {
        // Si clientId est fourni, on récupère les factures du client, sinon on récupère toutes les factures
        const url = clientId ? (BClientFacturesUrl + clientId) : BFactureUrl;
        const response = await axiosInstance.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching factures:", error);
        throw error;
    }
});


export const updateFacture = createAsyncThunk('update-facture', async (facture) => {
    try {
        const response = await axiosInstance.put(FACTURE_EDIT_URL, facture);
        return response.data;
    } catch (error) {
        console.error("Error updating facture:", error);
        throw error;
    }
});



export const calculateTotalFrais = (frais) => {
    if (!frais || (frais.length < 0)) return 0;

    const totalFrais = frais.reduce((total, frai) => {

        return { montant: total.montant + frai.montant };
    }, { montant: 0 });
    output({ totalFrais });
    return totalFrais.montant;
}

export const createFacture = (facture, err, cb) => {
    axiosInstance.post(FACTURATION_URL, facture)
        .then((response) => {
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const createDevis = (devis, err, cb) => {
    axiosInstance.post(MAKE_DEVIS_URL, devis)
        .then((response) => {
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}


export const cancelTickets = (facture, err, cb) => {
    axiosInstance.put(CANCEL_TICKETS_URL, facture)
        .then((response) => {
            output(response);
            // Axios throws on 4xx/5xx automatically, so checks might be redundant but safe
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error); // Pass full error object or error.response
        });
}

export const fetchFacture = async (id) => {
    return await axiosInstance.get(`${BFactureUrl + id}`);
}


export const updateTickets = (facture, err, cb) => {
    axiosInstance.put(UPDATE_TICKETS_URL, facture)
        .then((response) => {
            cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}



const factureSlice = createSlice({

    name: 'factures',
    initialState: { factures: [], fetchStatus: '', selectedFacture: {}, updateStatus: '' },
    reducers: {


        initialize: (state, action) => {
            state.updateStatus = '';
            state.fetchStatus = '';
        }



    },
    extraReducers: (builder) => {
        builder.addCase(fetchFactures.fulfilled, (state, action) => {

            let placeholder = action.payload;

            // Safety check if payload is string (should not happen with standard fetch response.json())
            if (typeof placeholder === 'string') {
                try {
                    placeholder = JSON.parse(placeholder);
                } catch (e) {
                    console.error("Failed to parse factures payload:", e);
                    placeholder = [];
                }
            }

            if (!Array.isArray(placeholder) && placeholder['hydra:member']) {
                placeholder = placeholder['hydra:member'];
            }

            if (Array.isArray(placeholder)) {

                placeholder = placeholder.map((facture) => {
                    if (facture.dossier) {
                        // Factures de production (Circuit, Séjour, etc.)
                        const dossierType = facture.dossier.type || '';
                        facture.type_facture = dossierType.toUpperCase() || "PRODUCTION";
                    } else if (!(facture.frais.length > 0) && facture.factureReferente) {
                        facture.type_facture = "Annulation de billet";
                    } else if (facture.factureReferente && (facture.frais.length > 0)) {
                        facture.type_facture = "UPDATE";
                    } else if (!facture.factureReferente) {
                        facture.type_facture = "Vente de billet";
                    }
                    facture.date = new Date(facture.createdAt).toLocaleDateString("fr-FR");
                    return facture;
                });

                // Trier par date la plus récente (createdAt décroissant)
                placeholder.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

                output(placeholder);
                state.factures = placeholder;
            } else {
                state.factures = [];
                console.error("fetchFactures payload is not an array");
            }
            state.fetchStatus = 'success';
        }).addCase(fetchFactures.pending, (state, action) => {
            // state.Factures[]
            state.fetchStatus = 'loading';
            state.updateStatus = 'loading';

        }).addCase(fetchFactures.rejected, (state, action) => {
            // state.Factures[]
            output(action);

            state.fetchStatus = 'error';

        }).addCase(updateFacture.pending, (state, action) => {
            state.updateStatus = 'loading';

        }).addCase(updateFacture.rejected, (state, action) => {
            state.updateStatus = 'error';

        })
            .addCase(updateFacture.fulfilled, (state, action) => {
                state.updateStatus = 'success';

                let facture = action.payload;
                state.factures = state.factures.map((fac) => {
                    if (facture.id === fac.id) {
                        fac = facture;
                    }
                    return fac;
                });
                output({ update: facture });


            })

            ;


    }


});


export default factureSlice;